export const intendedUseOfAssets = [
  { label: 'Investment', value: 'Investment' },
  // { label: 'Investment (short term)', value: 'Investment (short term)' },
  // { label: 'Investment (long term)', value: 'Investment (long term)' },
  // { label: 'Ecosystem Participation', value: 'Ecosystem Participation' },
  { label: 'Other (please describe)', value: 'Other (please describe)' }
]
